module.exports = __webpack_public_path__ + "static/media/ic-flag-my.9a54c47d.svg";